import { cn } from '../../utils/cn';

/**
 * Cartão em gradiente sage dos heroes de ciclo.
 *
 * `.pen`:
 * - `hero`       → `ds/card/cycle-spend-hero` › `hero` (e os gémeos `--tight` /
 *                  `--income`): `layout: vertical`, `gap $space-5`, `padding
 *                  $space-6`, `cornerRadius $radius-ds-xl`, fill gradiente
 *                  linear 215° `$sage-gradient-hero-from → -to`. Sem sombra —
 *                  os masters desta família não têm `effect`. As variáveis
 *                  `--sage-gradient-hero-*` já trocam de valor em dark, por
 *                  isso não é preciso variante `dark:` no gradiente.
 * - `tight`      → `ds/card/cycle-spend-hero--tight`: mesmo gradiente +
 *                  contorno `$warning-500` (o texto continua `$on-hero`).
 * - `heroDanger` → `ds/card/budget-allocation-hero--excesso`: mesmo
 *                  gradiente sage do `hero`, só acrescenta contorno
 *                  `$warning-500` — usado pelo hero de Orçamento em estado
 *                  de excesso.
 * - `surface`    → cartão neutro (ainda usado por Rendimentos até à sua
 *                  migração).
 */
const VARIANTS = {
  hero: {
    id: 'ds/card/cycle-spend-hero',
    className: '',
  },
  tight: {
    id: 'ds/card/cycle-spend-hero--tight',
    className: 'border border-warning-500',
  },
  heroDanger: {
    id: 'ds/card/budget-allocation-hero--excesso',
    className: 'border border-warning-500',
  },
  surface: {
    id: 'ds/card/kpi-glass--surface',
    className:
      'flex flex-col gap-space-2 rounded-ds-lg border border-border bg-card px-space-3 py-space-2-5 text-foreground',
  },
};

/**
 * @param {{
 *   variant?: 'hero' | 'tight' | 'heroDanger' | 'surface',
 *   className?: string,
 *   children: import('react').ReactNode,
 * }} props
 */
export function HeroCard({ variant = 'hero', className, children }) {
  const config = VARIANTS[variant] || VARIANTS.hero;

  return (
    <div
      data-ds-id={config.id}
      className={cn(
        'flex min-w-0 flex-col gap-space-5 overflow-hidden rounded-ds-xl bg-gradient-to-br from-sage-gradient-hero-from to-sage-gradient-hero-to p-space-6 text-sage-50',
        config.className,
        className,
      )}
    >
      {children}
    </div>
  );
}

export default HeroCard;
